import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { VideoSequencer } from './VideoSequencer';
import { reel } from '../data/media';
const panes = [{
  label: 'Mobile Pop-ups',
  to: '/work?category=Mobile+Tour'
}, {
  label: 'Experiential',
  to: '/work?category=Activation'
}, {
  label: 'Production',
  to: '/about'
}];
export function HeroStage() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start start', 'end start']
  });
  const mediaScale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const mediaOpacity = useTransform(scrollYProgress, [0, 1], [1, 0.25]);
  const chromeOpacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);
  return <section ref={sectionRef} className="relative h-[calc(100svh-4.5rem)] min-h-[32rem] w-full overflow-hidden" data-id="element-50" data-mp="2ypecivnqaz1g">
      <motion.div style={{
      scale: mediaScale,
      opacity: mediaOpacity
    }} className="absolute inset-0" data-id="element-51" data-mp="2tqulwhy6wz2r">
        <VideoSequencer videos={reel.videos} poster={reel.poster} caption={reel.caption} showControls={false} className="h-full w-full" data-id="element-52" data-mp="33hivo1cnizyz" />
        <div className="absolute inset-0 bg-ink/65" data-id="element-53" data-mp="3cdzz0ierxtk6" />
      </motion.div>

      <motion.h1 style={{
      opacity: chromeOpacity
    }} className="pointer-events-none absolute left-6 top-8 z-20 max-w-xl font-display text-2xl font-medium uppercase leading-[1.05] text-cream md:left-10 md:top-12 md:text-4xl" data-id="element-54" data-mp="3ha8mqk71ev2y">
        Creating experiences
        <br data-id="element-55" data-mp="2tk4ge52gsh89" />
        <span className="text-lilac" data-id="element-56" data-mp="2tjkygoctdsu8">people remember</span>
      </motion.h1>

      <nav aria-label="Sections" className="absolute inset-x-0 bottom-0 z-10 grid h-full grid-cols-3" data-id="element-57" data-mp="2ykiofn42fr6a">
        {panes.map(pane => <Link key={pane.to} to={pane.to} className="group relative flex items-end justify-center border-l border-cream/15 pb-8 transition-colors first:border-l-0 hover:bg-ink/35 md:pb-12" data-id="element-58" data-mp="8xb4xvwdocbe">
            <span className="px-2 text-center font-display text-[0.65rem] uppercase tracking-micro text-cream transition-transform duration-500 group-hover:-translate-y-1.5 md:text-sm" data-id="element-59" data-mp="3fcyvi9u5brro">
              {pane.label}
            </span>
          </Link>)}
      </nav>
    </section>;
}